import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=2573fda0&scoped=true"
import script from "./product_detail.vue?vue&type=script&lang=js"
export * from "./product_detail.vue?vue&type=script&lang=js"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=2573fda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2573fda0",
  null
  
)

export default component.exports